import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ca5039e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_3 = { class: "contact" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("문제가 해결되지 않으셨나요?")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 채팅상담 ")
const _hoisted_6 = { class: "footer" }

import { onBeforeMount, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router';

import { useUserStore } from '@/store/modules/user'

import Button from '@/components/common/Button.vue'
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'
import { ExclamationMark, RightAngleBracket } from '@/styles/icon'
import { showChannelTalk } from '@/utils/channelTalk'
import { useWindowSize } from '@/utils/useWindowSize'
import { errorCode } from '@/constants/errorStatus';


export default /*#__PURE__*/_defineComponent({
  name: '404',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

const title = ref('페이지를 찾을 수 없습니다.')
const subFirst = ref('입력한 페이지가 정확한지 확인해 주세요.')
const subSecond = ref('관련 문의는 고객센터로 해주세요.')
const targetCode = ref('')

const handleToBack = () => {
  if (targetCode.value === errorCode.rrn_already_exists) {
    logout()
    return
  }
  router.back()
}

const logout = () => userStore.logout().then(() => {
  router.push({ name: 'login' })
}).catch(() => {
  throw new Error('fail to logout')
})

onBeforeMount(() => {
  const { code } = route.query

  if (code === errorCode.rrn_already_exists) {
    title.value = '이미 사용된 실명입니다.'
    subFirst.value = '기존에 본인인증하셨던 카카오 계정으로'
    subSecond.value = '다시 접속해 주세요.'
    targetCode.value = errorCode.rrn_already_exists
  }
})

const innerHeight = useWindowSize().height

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper",
    style: _normalizeStyle({minHeight: `${_unref(innerHeight)}px`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ExclamationMark), {
        size: 48,
        "fill-color": _unref(COLOR_SET).red01,
        "text-color": _unref(COLOR_SET).white
      }, null, 8, ["fill-color", "text-color"]),
      _createVNode(Text, {
        size: "24px",
        weight: "bold",
        margin: "20px 0 12px 0"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(title.value), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, { size: "16px" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(subFirst.value), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, { size: "16px" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(subSecond.value), 1)
        ]),
        _: 1
      }),
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Text, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: "talk-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(showChannelTalk) && _unref(showChannelTalk)(...args)))
        }, [
          _createVNode(Text, {
            color: _unref(COLOR_SET).white,
            size: "14px"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_unref(RightAngleBracket), {
            color: _unref(COLOR_SET).white
          }, null, 8, ["color"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Button, {
        text: "이전 페이지",
        width: "90%",
        onButton_click: handleToBack
      })
    ])
  ], 4))
}
}

})